import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconProviderSlotopia = ({ className }) => (
  <svg
    className={classNames('producers-svg-icon', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
  >
    <mask id="mask0_242_1089" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="24">
      <path d="M18.6667 0H0V24H18.6667V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_242_1089)">
      <path
        d="M14.7483 6.24475C15.6513 5.58347 16.3507 4.67762 16.7657 3.63185C16.0329 3.20292 15.2171 2.93883 14.3739 2.85761C13.5308 2.7764 12.6802 2.87994 11.8804 3.16122C11.8144 3.18342 11.7529 3.21673 11.687 3.24114C11.2475 1.97576 10.3289 0.861344 9.33772 0C8.35098 0.861344 7.417 1.97576 6.97966 3.24114C6.91373 3.21673 6.85221 3.18342 6.78628 3.16122C5.98641 2.87994 5.13587 2.7764 4.29273 2.85761C3.4496 2.93883 2.63378 3.20292 1.90095 3.63185C2.3164 4.67675 3.0148 5.58229 3.91618 6.24475C1.23507 7.51456 0 9.9654 0 12.1831C0 14.9004 1.92073 17.4422 4.28539 20.2016C6.33136 22.5926 6.89835 24.0001 9.33991 24.0001C11.7815 24.0001 12.3397 22.5926 14.3945 20.2016C16.7591 17.4422 18.6798 14.9004 18.6798 12.1831C18.6666 9.9654 17.4294 7.51456 14.7483 6.24475Z"
        fill="#FF3F13"
      />
      <path
        d="M13.5442 10.8778C12.608 9.92982 10.8477 9.56798 9.33357 10.5137V5.15027L5.224 10.1141C3.66368 11.6903 3.97575 13.6172 5.12072 14.776C6.05691 15.7217 7.81939 16.0836 9.33357 15.1379V20.4902L13.4409 15.5241C15.0012 13.948 14.6892 12.021 13.5442 10.8778Z"
        fill="white"
      />
    </g>
  </svg>
);

IconProviderSlotopia.propTypes = {
  className: PropTypes.string
};

IconProviderSlotopia.defaultProps = {
  className: ''
};
